import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

interface Props {}

export const CardContainer = ({ children }: PropsWithChildren<Props>) => {
  const classes = useStyles();

  return <Box className={classes.container}>{children}</Box>;
};

const useStyles = makeStyles(({ shadows }) => ({
  container: {
    gap: '0.5rem',
    display: 'flex',
    boxShadow: shadows[2],
    borderRadius: '0.5rem',
    flexDirection: 'column',
    padding: '0.75rem 1.5rem',
    position: 'relative',
  },
}));
